// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__qmoJL","banner":"Hero_banner__s8tff","scroll":"Hero_scroll__IFppg","moveUpDown":"Hero_moveUpDown__zpxFe"};